
import React from 'react';
import { Button } from '@/components/ui/button';
import { Upload, X } from 'lucide-react';

interface FileUploadStepProps {
  fileInputRef: React.RefObject<HTMLInputElement>;
  file: File | null;
  isDisabled: boolean;
  onReset: () => void;
}

const FileUploadStep: React.FC<FileUploadStepProps> = ({ 
  fileInputRef, 
  file, 
  isDisabled, 
  onReset 
}) => {
  return (
    <div className="mb-6">
      <h2 className="text-lg font-medium mb-2">Step 2: Upload Your File</h2>
      <p className="text-muted-foreground mb-4">
        Fill in the template with your data and upload it here. We accept Excel (.xlsx) or CSV files.
      </p>
      
      <div className="flex items-center space-x-4">
        <Button
          variant="outline"
          onClick={() => fileInputRef.current?.click()}
          disabled={isDisabled}
        >
          <Upload className="mr-2 h-4 w-4" />
          {file ? 'Change File' : 'Select File'}
        </Button>
        
        {file && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onReset}
            disabled={isDisabled}
          >
            <X className="mr-1 h-4 w-4" />
            Clear
          </Button>
        )}
      </div>
      
      {file && (
        <p className="mt-2 text-sm">
          Selected file: <span className="font-medium">{file.name}</span>
        </p>
      )}
    </div>
  );
};

export default FileUploadStep;
